// -------------------------------- DEPENDENCIES -------------------------------- //

import React from "react";

// -------------------------------- COMPONENT -------------------------------- //

export default function Mazeletter(props) {
  return (
    <div id="mazeletter-backdrop">
      <p className="mazeletter-txt">ericpowelldeveloperdesignerericpowelldeveloperdesigner</p>
      <p className="mazeletter-txt">designerdeveloperericpowelldesignerdeveloperericpowell</p>
      <p className="mazeletter-txt">ericpowelldeveloperdesignerericpowelldeveloperdesigner</p>
      <p className="mazeletter-txt">designerdeveloperericpowelldesignerdeveloperericpowell</p>
      <p className="mazeletter-txt">ericpowelldeveloperdesignerericpowelldeveloperdesigner</p>
      <p className="mazeletter-txt">designerdeveloperericpowelldesignerdeveloperericpowell</p>
      <p className="mazeletter-txt">ericpowelldeveloperdesignerericpowelldeveloperdesigner</p>
      <p className="mazeletter-txt">designerdeveloperericpowelldesignerdeveloperericpowell</p>
      <p className="mazeletter-txt">ericpowelldeveloperdesignerericpowelldeveloperdesigner</p>
      <p className="mazeletter-txt">designerdeveloperericpowelldesignerdeveloperericpowell</p>
      <p className="mazeletter-txt">ericpowelldeveloperdesignerericpowelldeveloperdesigner</p>
      <p className="mazeletter-txt">designerdeveloperericpowelldesignerdeveloperericpowell</p>
      <p className="mazeletter-txt">ericpowelldeveloperdesignerericpowelldeveloperdesigner</p>
      <p className="mazeletter-txt">designerdeveloperericpowelldesignerdeveloperericpowell</p>
    </div>
  );
}
